<template>
  <div class="container">
    <a
      v-for="sdk in sdks_info"
      v-bind:key="sdk.url"
      class="sdk"
      :href="sdk.url"
      @click.capture="trackSdk(sdk)"
      target="_blank"
    >
      <el-card class="card" shadown="hover" :style="sdk.ready ? '' : 'opacity: 0.5;'">
        <div class="content">
          <img :src="sdk.logo" class="image" />
          <div class="name">{{ sdk.name }}</div>
          <div class="framework">{{ sdk.frameworks }}</div>
        </div>
      </el-card>
    </a>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      // https://www.vectorlogo.zone/index.html
      sdks: [
        {
          name: "Swift",
          frameworks: "Vapor",
        },
        {
          name: "Python",
          frameworks: "Django / Flask / WSGI",
        },
        {
          name: "Javascript",
          frameworks: "Node / Express",
          repository: 'js'
        },
        {
          name: "Go",
          frameworks: "Gin / Beego",
        },
        {
          name: "Ruby",
          frameworks: "Rack / Rails",
        },
        {
          name: "PHP",
          frameworks: "Laravel",//Symfony / 
        },
        {
          name: "Nginx",
          frameworks: "Lua / OpenResty",
        },
        {
          name: "Traefik",
          ready: false
        },
        {
          name: "Apache",
          ready: false
        },
        {
          name: "Kong"
        },
      ]
    };
  },
  computed: {
    sdks_info() {
      return this.sdks.map((e) => {
        return {
        ...e,
        ...{
          logo: require("@/assets/images/sdks-logos/" + e.name.toLowerCase() + ".svg"),
          url: "https://bitbucket.org/drhttp/drhttp-" + (e.repository || e.name).toLowerCase() + "/src/master/README.md",
          ready: e.ready != undefined ? e.ready : true
        }}
      }) 
    },
  },
  methods: {
    trackSdk(sdk) {
      this.$matomo.trackEvent("SDK", "browse", "name", sdk.name.toLowerCase());
    }
  }
};
</script>

<style scoped lang="sass">
.container
  @include flex($h: center, $v: stretch)
  flex-wrap: wrap
  max-width: 770px

  .sdk
    font-size: 13px

    .card
      margin: 5px

      .content
        width: 140px
        height: 150px
        @include flex($h: flex-start, $v: center)
        flex-direction: column

        img
          width: 100px
          height: 100px
          padding-bottom: 10px

        .name
          color: $color-primary
          font-weight: bold

        .framework
          color: $color-primary-light
</style>